window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.BackDisabled = function() {
	this.initialize(img.MainAssets_BackDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.BackDown = function() {
	this.initialize(img.MainAssets_BackDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.Background_Blue = function() {
	this.initialize(img.MainAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.BackUp = function() {
	this.initialize(img.MainAssets_BackUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.BigPanelBG = function() {
	this.initialize(img.MainAssets_BigPanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1080,1743);


(lib.Birdtut1 = function() {
	this.initialize(img.MainAssets_Birdtut1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,797,235);


(lib.Birdtut2 = function() {
	this.initialize(img.MainAssets_Birdtut2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,863,412);


(lib.Birdtut3 = function() {
	this.initialize(img.MainAssets_Birdtut3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,822,712);


(lib.Birdtut5 = function() {
	this.initialize(img.MainAssets_Birdtut5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,862,412);


(lib.BottomFloatingPanelBG = function() {
	this.initialize(img.MainAssets_BottomFloatingPanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1046,214);


(lib.Button_disabled = function() {
	this.initialize(img.MainAssets_Button_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_down = function() {
	this.initialize(img.MainAssets_Button_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_up = function() {
	this.initialize(img.MainAssets_Button_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.EndScreen = function() {
	this.initialize(img.MainAssets_EndScreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.EndscreenBGPanelShorter = function() {
	this.initialize(img.MainAssets_EndscreenBGPanelShorter);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1002,509);


(lib.FeedbackPopup_Left = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Left);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.FeedbackPopup_Middle = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Middle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,126,75);


(lib.FeedbackPopup_Right = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Right);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.GreenOrange_01 = function() {
	this.initialize(img.MainAssets_GreenOrange_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,221);


(lib.GreenOrange_01_tutorial = function() {
	this.initialize(img.MainAssets_GreenOrange_01_tutorial);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,174,241);


(lib.HUDPanelTop = function() {
	this.initialize(img.MainAssets_HUDPanelTop);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,996,168);


(lib.HUDPracticePanelBG = function() {
	this.initialize(img.MainAssets_HUDPracticePanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,996,170);


(lib.MainButtonDis = function() {
	this.initialize(img.MainAssets_MainButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonDown = function() {
	this.initialize(img.MainAssets_MainButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonHi = function() {
	this.initialize(img.MainAssets_MainButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonUp = function() {
	this.initialize(img.MainAssets_MainButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MoveNudge = function() {
	this.initialize(img.MainAssets_MoveNudge);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,267,268);


(lib.PopupBG = function() {
	this.initialize(img.MainAssets_PopupBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1123,787);


(lib.SmallPopupPanelBG = function() {
	this.initialize(img.MainAssets_SmallPopupPanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,682,374);


(lib.SpotterTimerBG = function() {
	this.initialize(img.MainAssets_SpotterTimerBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,143,143);


(lib.SpotterTimerOutline = function() {
	this.initialize(img.MainAssets_SpotterTimerOutline);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,143,143);


(lib.StopWatchIcon = function() {
	this.initialize(img.MainAssets_StopWatchIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,104,104);


(lib.WhiteArrow = function() {
	this.initialize(img.MainAssets_WhiteArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,73,61);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.ProgressDotTween = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#DDE5F0").s().p("Ag/BAQgagbAAglQAAgkAagbQAbgaAkAAQAkAAAbAaQAbAbAAAkQAAAlgbAbQgbAagkAAQgkAAgbgag");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-9,-9,18,18);


(lib.Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(47,47,47,0)").ss(4,2,1).p("EhmrikcMDNXAAAQCjAAAACbMAAAFECQAACcijAAMjNXAAAQijAAAAicMAAAlECQAAibCjAAg");
	this.shape.setTransform(673.475,1052.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#0E95FD").s().p("EhmrCkdQijAAAAicMAAAlEBQAAicCjAAMDNXAAAQCjAAAACcMAAAFEBQAACcijAAg");
	this.shape_1.setTransform(673.475,1052.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Overlay, new cjs.Rectangle(-2,-2,1351,2109), null);


(lib.HudBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.HUDPanelTop();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HudBackground, new cjs.Rectangle(0,0,996,168), null);


(lib.GateKeeperOverlayBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BigPanelBG();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GateKeeperOverlayBackground, new cjs.Rectangle(0,0,1080,1743), null);


(lib.TutorialLines5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("Eg2/AQeMBt/AAAMAAAgg7");
	this.shape.setTransform(-43.025,-21.425);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines5, new cjs.Rectangle(-396,-127.8,706,212.8), null);


(lib.TutorialLines4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EhECgj2MCIFAAAMAAABHtIpYAA");
	this.shape.setTransform(32.925,313.45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines4, new cjs.Rectangle(-403.6,83,873.1,461), null);


(lib.TutorialLines3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("Eg41AalMBxrAAAMAAAg1J");
	this.shape.setTransform(0,54.85);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines3, new cjs.Rectangle(-364.7,-116.2,729.5,342.2), null);


(lib.TutorialLines2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EhD9g1WMCH7AAAMAAABqu");
	this.shape.setTransform(0,-261.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines2, new cjs.Rectangle(-436,-604,872,685.1), null);


(lib.TutorialLines1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EhD8g7zMCH5AAAMAAAB3n");
	this.shape.setTransform(0.025,-250.7875);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines1, new cjs.Rectangle(-435.9,-634.6,871.9,767.7), null);


(lib.TutorialButtonHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApkC3IAAltITJAAIAAFtg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialButtonHitarea, new cjs.Rectangle(-61.2,-18.2,122.5,36.5), null);


(lib.TutorialBackgroundMap = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// nudge icon
	this.instance = new lib.MoveNudge();
	this.instance.setTransform(-133.5,158);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.instance_1 = new lib.Birdtut3();
	this.instance_1.setTransform(-411,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundMap, new cjs.Rectangle(-667.5,-1238,1335,2476), null);


(lib.TutorialBackgroundBird = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EAgcBUYMhA3AAAEAgchUXMAAACov");
	this.shape.setTransform(232.8,174.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// findLabelTextfield
	this.findLabelTextfield = new cjs.Text("Gesucht wird:", "39px 'Poppins SemiBold'", "#0F5184");
	this.findLabelTextfield.name = "findLabelTextfield";
	this.findLabelTextfield.lineHeight = 66;
	this.findLabelTextfield.lineWidth = 345;
	this.findLabelTextfield.parent = this;
	this.findLabelTextfield.setTransform(-310,87);
ranj.TextOffsetFixer.fix(this.findLabelTextfield);

	this.timeline.addTween(cjs.Tween.get(this.findLabelTextfield).wait(1));

	// bird
	this.instance = new lib.GreenOrange_01();
	this.instance.setTransform(160,4.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.instance_1 = new lib.Birdtut1();
	this.instance_1.setTransform(-398.5,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundBird, new cjs.Rectangle(-667.5,-1238,1335,2476), null);


(lib.PracticeIndicatorSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.textfield = new cjs.Text("xPractice level", "51px 'Poppins SemiBold'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 90;
	this.textfield.lineWidth = 943;
	this.textfield.parent = this;
	this.textfield.setTransform(-11,-84.65);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg BITMAPS
	this.instance = new lib.HUDPracticePanelBG();
	this.instance.setTransform(-498,-85);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PracticeIndicatorSkin, new cjs.Rectangle(-796.3,-86.6,1491.5,171.6), null);


(lib.GateKeeperOverlayLines = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("Eg9tANIMB7bAAAIAA6P");
	this.shape.setTransform(-0.025,-0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GateKeeperOverlayLines, new cjs.Rectangle(-396,-85,792,170), null);


(lib.DragNudge = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.instance = new lib.MoveNudge();
	this.instance.setTransform(-133.5,-134);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DragNudge, new cjs.Rectangle(-133.5,-134,267,268), null);


(lib.Dot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("AhFBGQgegdAAgpQAAgoAegdQAcgeApAAQApAAAeAeQAdAdAAAoQAAApgdAdQgeAegpAAQgpAAgcgeg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,20,20);


(lib.TutorialStep3Container = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("Egy2gUxMBltAAAQCVAABqBpQBpBqAACVIAAeTQAACVhpBqQhqBpiVAAMhltAAAQiVAAhqhpQhphqAAiVIAA+TQAAiVBphqQBqhpCVAAg");
	this.shape.setTransform(361.5,185.7);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("Egy2AUyQiVAAhqhqQhphpAAiVIAA+TQAAiVBphpQBqhqCVAAMBltAAAQCVAABpBqQBqBpAACVIAAeTQAACVhqBpQhpBqiVAAg");
	this.shape_1.setTransform(361.5,185.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep3Container, new cjs.Rectangle(-1,51.7,725,268), null);


(lib.LevelPlaceholder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("[level]", "150px 'Arial'", "#FF0000");
	this.text.textAlign = "center";
	this.text.lineHeight = 162;
	this.text.lineWidth = 610;
	this.text.alpha = 0.80000000;
	this.text.parent = this;
	this.text.setTransform(307.05,2);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelPlaceholder, new cjs.Rectangle(0,0,614.2,268.3), null);


(lib.FeedbackPopupBG_Right = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Right();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Right, new cjs.Rectangle(0,0,50,75), null);


(lib.FeedbackPopupBG_Middle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Middle();
	this.instance.setTransform(-2,0,1.0482,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Middle, new cjs.Rectangle(-2,0,132.1,75), null);


(lib.FeedbackPopupBG_Left = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Left();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Left, new cjs.Rectangle(0,0,50,75), null);


(lib.StartGameButton_Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Start\nStart", "16px 'Arial'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 23;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Start\nStart", "16px 'Arial'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 23;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Start\nStart", "16px 'Arial'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 23;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Start\nStart", "16px 'Arial'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 23;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-34.6,0.4,0.4323);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-34.85,0.4,0.4323);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-34.6,0.4,0.4323);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1,p:{y:-34.85}}]},1).to({state:[{t:this.instance_1,p:{y:-34.4}}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-34.8,173.2,73.9);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.WhiteArrow();
	this.instance.setTransform(97,-31);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 47;
	this.downLabelTextField.lineWidth = 276;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-32.95,-37);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 47;
	this.upLabelTextField.lineWidth = 276;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-32.95,-37);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 47;
	this.overLabelTextField.lineWidth = 276;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-32.95,-37);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 47;
	this.disabledLabelTextField.lineWidth = 276;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-32.95,-37);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance_1 = new lib.MainButtonUp();
	this.instance_1.setTransform(-210,-63);

	this.instance_2 = new lib.MainButtonHi();
	this.instance_2.setTransform(-210,-63);

	this.instance_3 = new lib.MainButtonDown();
	this.instance_3.setTransform(-210,-63);

	this.instance_4 = new lib.MainButtonDis();
	this.instance_4.setTransform(-210,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-210,-63,419,128);


(lib.ChangeBirdButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Down
	this.downLabelTextField = new cjs.Text("Change bird", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 47;
	this.downLabelTextField.lineWidth = 336;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-2.9,-38);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Change bird", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 47;
	this.upLabelTextField.lineWidth = 336;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-2.9,-38);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Change bird", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 47;
	this.overLabelTextField.lineWidth = 336;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-2.9,-38);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Change bird", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 47;
	this.disabledLabelTextField.lineWidth = 336;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-2.9,-38);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.MainButtonUp();
	this.instance.setTransform(-210,-63);

	this.instance_1 = new lib.MainButtonHi();
	this.instance_1.setTransform(-210,-63);

	this.instance_2 = new lib.MainButtonDown();
	this.instance_2.setTransform(-210,-63);

	this.instance_3 = new lib.MainButtonDis();
	this.instance_3.setTransform(-210,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-210,-63,419,126);


(lib.BirdTEMP = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0000FF").ss(1,1,1).p("AEpAAQAAB7hXBXQhXBXh7AAQh6AAhXhXQhXhXAAh7QAAh6BXhXQBXhXB6AAQB7AABXBXQBXBXAAB6g");
	this.shape.setTransform(-0.025,-30.125);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AjRDSQhXhXAAh7QAAh6BXhXQBXhXB6AAQB7AABXBXQBXBXAAB6QAAB7hXBXQhXBXh7AAQh6AAhXhXg");
	this.shape_1.setTransform(-0.025,-30.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BirdTEMP, new cjs.Rectangle(-30.7,-60.8,61.4,61.4), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-667,-1286,1.3655,1.3655);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667,-1286,1334.1,2802), null);


(lib.TimerFill = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("AlXLAIgIAAIAA1/IAIAAIABAAQEeADDKDMQDODOAAEiQAAEkjODOQjKDKkeAEg");
	this.shape.setTransform(0,-0.1,0.9282,0.9282,0,0,0,-35.3,-0.2);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#0F97FF").s().p("AAALAQkiAAjPjOQjOjOAAkkQAAkiDOjOQDPjPEiAAQEkAADODPQDODOAAEiQAAEkjODOQjODOkkAAIAAAAg");
	this.shape_1.setTransform(0.0249,0.0533,0.9416,0.9415);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},49).to({state:[{t:this.shape_1}]},51).wait(1));

	// Layer_3 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AiLHWQjFjDAAkTQAAkTDFjDQDDjCEWAAIACA4IABTaQgBAfgCAAQkXAAjCjDg");
	var mask_graphics_1 = new cjs.Graphics().p("AEPKZQkUgSi3jPQi4jPASkTQASkSDQi2QDPi2EVASIgBA4IhPTYQgDAfgCAAIAAAAg");
	var mask_graphics_2 = new cjs.Graphics().p("ADQKXQkTgkipjaQiqjbAjkQQAjkRDcioQDaioEUAjIgFA5IieTQQgGAegBAAIAAAAg");
	var mask_graphics_3 = new cjs.Graphics().p("ACRKUQkQg1ibjlQibjlA0kOQA1kODmiaQDkiZERA1IgJA4IjtTDQgHAegBAAIAAAAg");
	var mask_graphics_4 = new cjs.Graphics().p("ABSKPQkMhGiLjvQiNjuBGkJQBGkLDviKQDuiLENBGIgMA4Ik7SxQgJAdgCAAIAAAAg");
	var mask_graphics_5 = new cjs.Graphics().p("AAVKJQkHhXh8j3Qh8j3BWkEQBXkFD4h7QD2h8EHBYIgQA2ImGSbQgLAcgCAAIAAAAg");
	var mask_graphics_6 = new cjs.Graphics().p("AgmKCQkChohsj+Qhsj+Bnj/QBoj/D+hrQD+hrEBBoIgTA1InRR/QgMAcgCAAIAAAAg");
	var mask_graphics_7 = new cjs.Graphics().p("AhhJ5Qj6h4hbkFQhckDB3j4QB4j4EFhbQEEhaD5B4IgWA0IoaRfQgOAbgCAAIAAgBg");
	var mask_graphics_8 = new cjs.Graphics().p("AiaJwQjyiJhKkKQhLkICHjwQCHjwEKhKQEJhJDyCIIgaAyIpgQ6QgQAagCAAIAAAAg");
	var mask_graphics_9 = new cjs.Graphics().p("AjRJkQjoiXg6kOQg5kNCWjnQCWjnENg4QEOg4DpCXIgdAwIqkQRQgSAYgCAAIAAAAg");
	var mask_graphics_10 = new cjs.Graphics().p("AkGJYQjeimgokRQgokQCljdQCkjcEQgnQESgnDeClIggAvIrmPjQgSAXgCAAIgBAAg");
	var mask_graphics_11 = new cjs.Graphics().p("Ak4JKQjTizgWkTQgXkSCzjSQCyjSESgVQETgWDTC0IgjAsIskOyQgUAVgCAAIAAAAg");
	var mask_graphics_12 = new cjs.Graphics().p("AloI8QjHjBgEkUQgFkTC/jGQDAjFETgEQETgEDHDBIglAqItfN8QgVAUgCAAIgBAAg");
	var mask_graphics_13 = new cjs.Graphics().p("AmUItQi6jOANkTQANkTDLi5QDMi5ETAOQETAOC6DNIgoAnIuWNDQgWATgDAAIAAAAg");
	var mask_graphics_14 = new cjs.Graphics().p("Am9IdQitjZAfkSQAekRDXisQDXirERAfQESAgCtDYIgrAlIvJMGQgYARgCAAIAAAAg");
	var mask_graphics_15 = new cjs.Graphics().p("AnjIMQifjjAxkQQAvkODiieQDiidEOAxQEPAxCfDiIgtAiIv5LGQgYAQgDAAIAAAAg");
	var mask_graphics_16 = new cjs.Graphics().p("AoGH6QiPjtBBkLQBBkLDsiPQDriOELBCQELBCCPDsIgvAfIwkKEQgZANgDAAIAAAAg");
	var mask_graphics_17 = new cjs.Graphics().p("AolHoQiAj2BTkGQBSkHD0h/QD0h/EFBTQEHBTCAD1IgxAcIxLI+QgZAMgEAAIAAAAg");
	var mask_graphics_18 = new cjs.Graphics().p("ApBHUQhwj8BkkAQBjkCD7hvQD7hvEABjQEBBkBwD9IgzAYIxtH3QgaAKgDAAIgBgBg");
	var mask_graphics_19 = new cjs.Graphics().p("ApZHBQhfkEBzj5QB0j6EChfQEBhfD6B0QD6B0BfEDIg0AUIyMGuQgZAIgEAAIgBAAg");
	var mask_graphics_20 = new cjs.Graphics().p("AptGsQhPkJCEjxQCDjyEIhOQEGhPDyCEQDyCEBOEHIg1ASIykFiQgZAHgFAAIgBgBg");
	var mask_graphics_21 = new cjs.Graphics().p("Ap9GXQg+kNCTjoQCSjpEMg+QELg9DpCTQDpCTA+EMIg3AOIy4EVQgYAFgGAAIgBgBg");
	var mask_graphics_22 = new cjs.Graphics().p("AqKGCQgskRChjeQChjfEQgsQEOgsDfChQDfCiAsEPIg3ALIzIDHIgcACIgDAAg");
	var mask_graphics_23 = new cjs.Graphics().p("AqSFsQgbkTCwjTQCujUESgbQERgaDUCvQDUCvAbESIg4AHIzSB4IgYABQgHAAAAgBg");
	var mask_graphics_24 = new cjs.Graphics().p("AqWFWQgJkUC8jHQC8jJETgJQESgJDIC9QDJC7AJEUIg5AEIzWAoQgfAAAAgCg");
	var mask_graphics_25 = new cjs.Graphics().p("AJfFXIzXgnQgfgCAAgCQAJkTDJi7QDJi9ESAJQESAJC8DJQC8DHgJEUIgVAAIgjAAg");
	var mask_graphics_26 = new cjs.Graphics().p("AJbFpIzSh2QgfgEABgCQAakSDViuQDUivEQAaQESAaCvDVQCuDTgaESIgBAAIg3gDg");
	var mask_graphics_27 = new cjs.Graphics().p("AJTF7IzIjFQgegHAAgBQAskQDfigQDfihEPAsQEPAsChDfQCgDegsEQIAAAAIg3gHg");
	var mask_graphics_28 = new cjs.Graphics().p("AJHGMIy4kTQgegIAAgCQA9kMDpiRQDpiTELA9QEMA+CSDoQCSDog9ENIAAAAIg3gLg");
	var mask_graphics_29 = new cjs.Graphics().p("AI3GdIyklgQgdgKAAgBQBPkIDxiCQDyiDEHBOQEHBOCDDyQCDDwhOEIIgBAAIg2gOg");
	var mask_graphics_30 = new cjs.Graphics().p("AIkGuIyLmrQgdgLABgCQBfkCD6hzQD5hzEBBeQECBfBzD6QBzD4hfECIAAAAIg1gRg");
	var mask_graphics_31 = new cjs.Graphics().p("AING+Ixtn0QgcgOABgBQBvj8EBhiQEAhjD7BvQD7BvBjEAQBjEAhwD7IAAAAIg0gVg");
	var mask_graphics_32 = new cjs.Graphics().p("AHzHOIxLo8QgbgPABgCQCAj0EGhSQEFhSD0B/QDzB/BSEGQBTEFh/D0IAAAAIgzgYg");
	var mask_graphics_33 = new cjs.Graphics().p("AHVHdIwjqBQgagRABgCQCPjrEKhBQEKhBDrCPQDrCOBBEKQBCEKiPDrIAAAAIgxgbg");
	var mask_graphics_34 = new cjs.Graphics().p("AG0HrIv3rDQgZgTABgBQCdjiEPgvQENgwDhCdQDiCdAwENQAwEOidDiIAAAAIgwgfg");
	var mask_graphics_35 = new cjs.Graphics().p("AGRH5IvJsDQgXgUABgCQCrjXERgeQEQgeDXCrQDWCrAfEQQAfERirDWIAAAAIgtghg");
	var mask_graphics_36 = new cjs.Graphics().p("AFqIGIuVs/QgWgWABgBQC5jMESgMQERgNDMC4QDLC5ANERQANESi4DLIAAAAIgrgkg");
	var mask_graphics_37 = new cjs.Graphics().p("AFAISItdt4QgVgXABgBQDFi/ETAFQERAEC/DGQC/DFgEERQgEESjFC/IAAAAIgpgng");
	var mask_graphics_38 = new cjs.Graphics().p("AETIeIsiutQgUgZACgBQDRiyERAXQERAWCyDRQCyDRgWERQgWERjRCyIAAAAIgmgqg");
	var mask_graphics_39 = new cjs.Graphics().p("ADkIpIrkvfQgSgZABgBQDcilEQApQEOAnCkDdQCkDbgnEPQgnEPjcCkIAAAAIgjgsg");
	var mask_graphics_40 = new cjs.Graphics().p("ACyI0IqjwNQgQgbACAAQDmiWEMA5QELA5CWDnQCVDlg4EMQg4EMjmCWIAAAAIghgug");
	var mask_graphics_41 = new cjs.Graphics().p("AB/I9Ipgw2QgOgbACgBQDviHEHBLQEIBKCGDvQCHDvhKEHQhJEIjvCHIAAAAIgdgwg");
	var mask_graphics_42 = new cjs.Graphics().p("ABJJFIoZxaQgMgdACAAQD3h3EBBbQEDBbB3D3QB3D3haECQhaEDj3B3IAAAAIgbgyg");
	var mask_graphics_43 = new cjs.Graphics().p("AASJMInQx6QgKgdABgBQD+hnD7BsQD8BrBnD/QBnD9hqD8QhrD9j9BmIAAAAIgYgzg");
	var mask_graphics_44 = new cjs.Graphics().p("AglJSImHyWQgIgeABAAQEFhWDzB7QD1B7BWEFQBXEDh7D1Qh6D1kDBXIAAAAIgUg1g");
	var mask_graphics_45 = new cjs.Graphics().p("AheJXIk7ytQgHgeACAAQEJhGDrCLQDsCLBGEJQBFEJiJDsQiKDtkIBFIAAAAIgQg1g");
	var mask_graphics_46 = new cjs.Graphics().p("AiYJaIjuy+QgEgeABgBQENg0DiCaQDiCZA1EOQA0EMiYDjQiZDkkMA0IAAAAIgMg3g");
	var mask_graphics_47 = new cjs.Graphics().p("AjTJcIifzKQgDgfACAAQEPgjDXCoQDZCoAjEQQAjEPinDZQinDZkOAjIAAAAIgJg4g");
	var mask_graphics_48 = new cjs.Graphics().p("AkOJeIhQzSQgBgfABAAQESgSDLC2QDOC1ARESQASEQi1DOQi0DOkQASIAAAAIgFg4g");
	var mask_graphics_49 = new cjs.Graphics().p("AlJJeIgBzUQABgfACAAQERAADADCQDBDCAAERQAAESjBDCQjADCkRAAIgCg4g");
	var mask_graphics_50 = new cjs.Graphics().p("AldKUIABg4IBMzSQADgfABAAQERARC0DOQC1DNgRERQgRESjNC1Qi6Cnj0AAIgugCg");
	var mask_graphics_51 = new cjs.Graphics().p("AlyKOIAFg4ICXzLQAFgeACAAQEPAiCnDYQCoDYgiEQQgiEQjXCoQizCNjaAAQgsAAgtgGg");
	var mask_graphics_52 = new cjs.Graphics().p("AmGKFIAIg4IDjy/QAHgeABAAQEMAyCaDjQCaDigyEMQgzEOjhCbQipB1jDAAQg/AAhCgMg");
	var mask_graphics_53 = new cjs.Graphics().p("AmaJ4IALg3IEtywQAJgdACAAQEIBDCMDrQCMDrhDEKQhDEJjrCNQieBgitAAQhSAAhVgVg");
	var mask_graphics_54 = new cjs.Graphics().p("AmuJnIAPg3IF2yaQALgdABAAQEEBTB9D0QB9DzhTEFQhTEFjzB+QiSBNiZAAQhkAAhnghg");
	var mask_graphics_55 = new cjs.Graphics().p("AnBJSIASg1IG9yBQAMgcACAAQD/BjBuD7QBuD6hjD/QhjEAj7BvQiDA7iGAAQh3AAh3gvg");
	var mask_graphics_56 = new cjs.Graphics().p("AnUI7IAVg0IIExkQAOgbABAAQD5BzBeEBQBeEBhzD4QhyD5kBBfQhzAshzAAQiKAAiHg+g");
	var mask_graphics_57 = new cjs.Graphics().p("AnnIfIAZgyIJIxCQAQgaABAAQDxCCBOEGQBOEGiBDxQiCDykGBPQhjAfhgAAQidAAiWhRg");
	var mask_graphics_58 = new cjs.Graphics().p("An4IBIAcgxIKKwbQARgaABABQDpCQA9ELQA/EJiRDqQiQDpkJA/QhSAThOAAQiyAAihhkg");
	var mask_graphics_59 = new cjs.Graphics().p("AoJHgIAfgvILJvyQATgYABABQDgCeAtEOQAtEMieDgQifDgkMAvQg+ALg7AAQjIAAish6g");
	var mask_graphics_60 = new cjs.Graphics().p("AoZG7IAigtIMGvEQAUgXABABQDWCsAcEQQAdEPisDWQisDVkPAeQgpAFgnAAQjgAAi1iSg");
	var mask_graphics_61 = new cjs.Graphics().p("AooGUIAkgrINAuSQAWgWABABQDKC4AMERQAMERi5DLQi5DKkQANIglABQj6AAi8irg");
	var mask_graphics_62 = new cjs.Graphics().p("AhnIxQkSgEi+jEIAngoIN3teQAXgUABABQC+DFgFERQgFERjFC/QjBC7kKAAIgKAAg");
	var mask_graphics_63 = new cjs.Graphics().p("AiCIgQkRgViyjPIApgmIOqslQAZgTABABQCyDQgWERQgWEPjQCzQi7CgjuAAQgbAAgcgCg");
	var mask_graphics_64 = new cjs.Graphics().p("AieILQkQglikjaIArgjIParqQAagSABACQClDagnEPQgnEOjbClQiyCHjVAAQgwAAgxgHg");
	var mask_graphics_65 = new cjs.Graphics().p("Ai7H0QkMg2iXjkIAtghIQGqrQAbgQABABQCXDkg4EMQg3EMjkCXQipBwi9AAQhEAAhGgOg");
	var mask_graphics_66 = new cjs.Graphics().p("AjYHZQkJhGiIjtIAvgeIQvprQAbgOABACQCJDthIEHQhIEIjtCJQidBbioAAQhXAAhZgYg");
	var mask_graphics_67 = new cjs.Graphics().p("Aj2G7QkEhWh5j1IAxgbIRTonQAcgNABABQB6D1hZEDQhXEDj2B6QiQBIiTAAQhpAAhsgkg");
	var mask_graphics_68 = new cjs.Graphics().p("AkUGaQj9hmhrj8IAzgYIRyniQAdgLABACQBrD8hoD8QhoD+j8BrQiBA2iBAAQh7AAh9gyg");
	var mask_graphics_69 = new cjs.Graphics().p("AkxF3Qj4h2hakBIA0gUISOmcQAdgJABABQBbECh3D2Qh3D2kDBbQhxAohtAAQiPAAiLhCg");
	var mask_graphics_70 = new cjs.Graphics().p("AlPFRQjwiFhLkGIA2gRISllUQAegHABACQBLEHiHDuQiFDukIBLQhgAchbAAQiiAAiZhVg");
	var mask_graphics_71 = new cjs.Graphics().p("AltEoQjniTg6kKIA2gOIS4kJQAegGABACQA6ELiUDlQiUDmkNA7QhMARhIAAQi4AAilhqg");
	var mask_graphics_72 = new cjs.Graphics().p("AmLD+QjdihgqkOIA3gKITGi/QAfgDAAABQAqEPiiDbQiiDckQArQg4AIg1AAQjOAAiwh/g");
	var mask_graphics_73 = new cjs.Graphics().p("AmoDRQjTivgZkPIA4gHITPhzQAfgCAAACQAZEQiwDRQivDSkRAaQgjADggAAQjoAAi4iYg");
	var mask_graphics_74 = new cjs.Graphics().p("AnFCiQjIi6gIkRIA4gEITUgnQAfAAAAACQAIESi8DFQi8DHkSAJIgXAAQkDAAi/izg");
	var mask_graphics_75 = new cjs.Graphics().p("AgUFUQkSgJi7jHQi8jGAIkRIA4AAITUAlQAfACAAACQgIESjIC5QjACzkDAAIgXAAg");
	var mask_graphics_76 = new cjs.Graphics().p("Ag7FlQkRgZivjSQivjRAZkQIA4ADITQBxQAeAEAAACQgZEPjTCuQi5CZjnAAQghAAgjgEg");
	var mask_graphics_77 = new cjs.Graphics().p("AhgF0QkPgqiijcQiijcAqkOIA4AHITGC9QAeAGAAABQgqEOjeCgQivCAjPAAQg1AAg4gJg");
	var mask_graphics_78 = new cjs.Graphics().p("AiEGBQkMg7iUjmQiUjlA6kLIA4AKIS4EIQAeAHgBACQg6ELjnCSQilBpi4AAQhJAAhMgQg");
	var mask_graphics_79 = new cjs.Graphics().p("AimGKQkIhLiGjvQiGjtBLkHIA3ANISmFSQAdAKAAABQhLEHjwCEQiZBUijAAQhbAAhfgbg");
	var mask_graphics_80 = new cjs.Graphics().p("AjHGRQkChbh3j3Qh3j1BbkCIA2ARISOGaQAdAMgBABQhbECj3B1QiLBCiPAAQhuAAhxgog");
	var mask_graphics_81 = new cjs.Graphics().p("AjlGVQj9hqhnj+Qhoj8Brj8IA1AUIRzHhQAcANgBABQhrD8j+BmQh8Ayh8AAQiAAAiBg3g");
	var mask_graphics_82 = new cjs.Graphics().p("AkCGXQj1h6hYkEQhXkCB5j1IA0AYIRTImQAbAOgBACQh6D1kDBWQhsAkhpAAQiUAAiQhIg");
	var mask_graphics_83 = new cjs.Graphics().p("AkcGWQjuiJhHkJQhHkHCIjsIAyAaIQvJpQAaAQAAACQiJDtkJBGQhaAYhWAAQioAAidhbg");
	var mask_graphics_84 = new cjs.Graphics().p("Ak0GSQjliYg3kLQg3kMCXjkIAwAeIQHKqQAZASAAABQiYDkkMA2QhGAOhEAAQi9AAiphwg");
	var mask_graphics_85 = new cjs.Graphics().p("AlKGLQjbilgmkOQgnkPCljaIAuAgIPbLoQAYAUgBABQilDbkPAkQgyAHgwAAQjUAAiziHg");
	var mask_graphics_86 = new cjs.Graphics().p("AldGCQjQizgWkQQgWkQCyjQIAsAjIOsMkQAWAVgBABQiyDQkRAUQgcACgbAAQjuAAi7igg");
	var mask_graphics_87 = new cjs.Graphics().p("AluF1QjEi+gFkRQgFkSC+jEIAqAmIN4NcQAWAWgCABQi+DFkSADIgKAAQkKAAjCi8g");
	var mask_graphics_88 = new cjs.Graphics().p("ABOI+QkQgNi5jLQi5jKAMkRQAMkRDKi4IAnAoINCORQAUAYgBABQi9Crj5AAIgmgBg");
	var mask_graphics_89 = new cjs.Graphics().p("AA1JIQkPgeisjWQisjVAdkPQAdkRDVirIAlArIMHPCQATAZgCABQi1CSjfAAQgoAAgpgFg");
	var mask_graphics_90 = new cjs.Graphics().p("AAdJPQkNgviejgQifjgAukNQAukODfieIAiAtILLPxQARAagCABQisB6jHAAQg8AAg+gLg");
	var mask_graphics_91 = new cjs.Graphics().p("AAGJSQkJhAiQjpQiRjpA+kKQA+kKDpiQIAfAvIKLQaQAQAbgCABQihBkixAAQhPAAhSgTg");
	var mask_graphics_92 = new cjs.Graphics().p("AgOJRQkGhPiCjyQiCjyBPkFQBOkGDxiCIAcAxIJKRBQANAcgBABQiVBQidAAQhhAAhjgfg");
	var mask_graphics_93 = new cjs.Graphics().p("AgjJNQkAhfhzj6Qhyj4BekBQBekBD5hyIAZAyIIFRjQAMAdgCABQiHA+iJAAQh0AAh0gsg");
	var mask_graphics_94 = new cjs.Graphics().p("Ag2JGQj6hvhjkAQhjj/Buj7QBuj6D/hjIAWA0IG/SBQAKAdgBABQh4Auh3AAQiGAAiEg7g");
	var mask_graphics_95 = new cjs.Graphics().p("AhHI7Qjzh+hTkGQhTkEB9jzQB9j0EEhTIATA1IF4SbQAIAdgCABQhnAhhkAAQiaAAiRhNg");
	var mask_graphics_96 = new cjs.Graphics().p("AhXItQjriNhDkKQhDkJCMjrQCMjsEIhCIAQA2IEvSvQAGAegCABQhVAVhSAAQitAAiehgg");
	var mask_graphics_97 = new cjs.Graphics().p("AhmIcQjiibgykOQgzkNCbjiQCajiEMgyIAMA3IDkS/QAFAfgCAAQhCAMg/AAQjDAAiph1g");
	var mask_graphics_98 = new cjs.Graphics().p("AhzIHQjYipgikQQghkPCojYQCnjZEPghIAJA3ICZTMQACAegBABQguAFgrAAQjbAAiyiNg");
	var mask_graphics_99 = new cjs.Graphics().p("Ah/HvQjNi1gQkTQgRkQC0jOQC1jNEQgRIAGA4IBNTSQAAAfgBABIguABQj1AAi6ing");
	var mask_graphics_100 = new cjs.Graphics().p("AiJHUQjBjCAAkSQAAkSDBjCQDAjCERAAIACA5IABTVQgBAfgCAAQkRAAjAjDg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:-33.5267,y:-0.15}).wait(1).to({graphics:mask_graphics_1,x:-31.5376,y:-0.2481}).wait(1).to({graphics:mask_graphics_2,x:-29.4338,y:-0.4975}).wait(1).to({graphics:mask_graphics_3,x:-27.3454,y:-0.888}).wait(1).to({graphics:mask_graphics_4,x:-25.2776,y:-1.4112}).wait(1).to({graphics:mask_graphics_5,x:-23.2353,y:-2.0605}).wait(1).to({graphics:mask_graphics_6,x:-21.2245,y:-2.8302}).wait(1).to({graphics:mask_graphics_7,x:-19.2528,y:-3.7158}).wait(1).to({graphics:mask_graphics_8,x:-17.329,y:-4.7141}).wait(1).to({graphics:mask_graphics_9,x:-15.4634,y:-5.8229}).wait(1).to({graphics:mask_graphics_10,x:-13.6675,y:-7.0413}).wait(1).to({graphics:mask_graphics_11,x:-11.9546,y:-8.3699}).wait(1).to({graphics:mask_graphics_12,x:-10.3397,y:-9.8109}).wait(1).to({graphics:mask_graphics_13,x:-8.8422,y:-11.3667}).wait(1).to({graphics:mask_graphics_14,x:-7.4618,y:-13.0265}).wait(1).to({graphics:mask_graphics_15,x:-6.1937,y:-14.7743}).wait(1).to({graphics:mask_graphics_16,x:-5.0364,y:-16.5959}).wait(1).to({graphics:mask_graphics_17,x:-3.9899,y:-18.4791}).wait(1).to({graphics:mask_graphics_18,x:-3.0554,y:-20.413}).wait(1).to({graphics:mask_graphics_19,x:-2.2353,y:-22.3881}).wait(1).to({graphics:mask_graphics_20,x:-1.5333,y:-24.3963}).wait(1).to({graphics:mask_graphics_21,x:-0.9538,y:-26.4304}).wait(1).to({graphics:mask_graphics_22,x:-0.5028,y:-28.484}).wait(1).to({graphics:mask_graphics_23,x:-0.1872,y:-30.5488}).wait(1).to({graphics:mask_graphics_24,x:-0.0158,y:-32.5928}).wait(1).to({graphics:mask_graphics_25,x:0.0414,y:-32.6563}).wait(1).to({graphics:mask_graphics_26,x:0.2131,y:-30.5553}).wait(1).to({graphics:mask_graphics_27,x:0.5288,y:-28.4597}).wait(1).to({graphics:mask_graphics_28,x:0.9794,y:-26.384}).wait(1).to({graphics:mask_graphics_29,x:1.5576,y:-24.3325}).wait(1).to({graphics:mask_graphics_30,x:2.2574,y:-22.3106}).wait(1).to({graphics:mask_graphics_31,x:3.0738,y:-20.325}).wait(1).to({graphics:mask_graphics_32,x:4.003,y:-18.3836}).wait(1).to({graphics:mask_graphics_33,x:5.0425,y:-16.496}).wait(1).to({graphics:mask_graphics_34,x:6.1908,y:-14.6729}).wait(1).to({graphics:mask_graphics_35,x:7.4476,y:-12.9266}).wait(1).to({graphics:mask_graphics_36,x:8.8145,y:-11.2712}).wait(1).to({graphics:mask_graphics_37,x:10.2947,y:-9.7238}).wait(1).to({graphics:mask_graphics_38,x:11.8862,y:-8.2961}).wait(1).to({graphics:mask_graphics_39,x:13.5739,y:-6.9813}).wait(1).to({graphics:mask_graphics_40,x:15.3428,y:-5.7768}).wait(1).to({graphics:mask_graphics_41,x:17.1799,y:-4.6817}).wait(1).to({graphics:mask_graphics_42,x:19.0738,y:-3.6968}).wait(1).to({graphics:mask_graphics_43,x:21.0145,y:-2.8236}).wait(1).to({graphics:mask_graphics_44,x:22.9932,y:-2.0653}).wait(1).to({graphics:mask_graphics_45,x:25.0025,y:-1.4256}).wait(1).to({graphics:mask_graphics_46,x:27.0357,y:-0.9097}).wait(1).to({graphics:mask_graphics_47,x:29.0864,y:-0.5239}).wait(1).to({graphics:mask_graphics_48,x:31.1412,y:-0.2757}).wait(1).to({graphics:mask_graphics_49,x:33.1139,y:-0.05}).wait(1).to({graphics:mask_graphics_50,x:31.2164,y:0.0372}).wait(1).to({graphics:mask_graphics_51,x:29.2081,y:0.2603}).wait(1).to({graphics:mask_graphics_52,x:27.2158,y:0.6108}).wait(1).to({graphics:mask_graphics_53,x:25.244,y:1.0818}).wait(1).to({graphics:mask_graphics_54,x:23.2964,y:1.6674}).wait(1).to({graphics:mask_graphics_55,x:21.3782,y:2.3629}).wait(1).to({graphics:mask_graphics_56,x:19.4953,y:3.1644}).wait(1).to({graphics:mask_graphics_57,x:17.6551,y:4.0692}).wait(1).to({graphics:mask_graphics_58,x:15.8659,y:5.0753}).wait(1).to({graphics:mask_graphics_59,x:14.1376,y:6.1817}).wait(1).to({graphics:mask_graphics_60,x:12.4809,y:7.3888}).wait(1).to({graphics:mask_graphics_61,x:10.9084,y:8.6979}).wait(1).to({graphics:mask_graphics_62,x:9.4355,y:10.1124}).wait(1).to({graphics:mask_graphics_63,x:8.0721,y:11.6309}).wait(1).to({graphics:mask_graphics_64,x:6.8118,y:13.2402}).wait(1).to({graphics:mask_graphics_65,x:5.6523,y:14.927}).wait(1).to({graphics:mask_graphics_66,x:4.593,y:16.6796}).wait(1).to({graphics:mask_graphics_67,x:3.6342,y:18.4876}).wait(1).to({graphics:mask_graphics_68,x:2.7774,y:20.3419}).wait(1).to({graphics:mask_graphics_69,x:2.0252,y:22.2344}).wait(1).to({graphics:mask_graphics_70,x:1.3809,y:24.1582}).wait(1).to({graphics:mask_graphics_71,x:0.8488,y:26.1071}).wait(1).to({graphics:mask_graphics_72,x:0.4344,y:28.0755}).wait(1).to({graphics:mask_graphics_73,x:0.144,y:30.0555}).wait(1).to({graphics:mask_graphics_74,x:-0.0145,y:32.0159}).wait(1).to({graphics:mask_graphics_75,x:-0.0685,y:32.0841}).wait(1).to({graphics:mask_graphics_76,x:-0.2266,y:30.0767}).wait(1).to({graphics:mask_graphics_77,x:-0.5162,y:28.0733}).wait(1).to({graphics:mask_graphics_78,x:-0.9296,y:26.0886}).wait(1).to({graphics:mask_graphics_79,x:-1.4605,y:24.1263}).wait(1).to({graphics:mask_graphics_80,x:-2.1035,y:22.1905}).wait(1).to({graphics:mask_graphics_81,x:-2.8544,y:20.287}).wait(1).to({graphics:mask_graphics_82,x:-3.7098,y:18.4223}).wait(1).to({graphics:mask_graphics_83,x:-4.6674,y:16.6043}).wait(1).to({graphics:mask_graphics_84,x:-5.7257,y:14.8421}).wait(1).to({graphics:mask_graphics_85,x:-6.8844,y:13.146}).wait(1).to({graphics:mask_graphics_86,x:-8.1442,y:11.5277}).wait(1).to({graphics:mask_graphics_87,x:-9.5076,y:10.0003}).wait(1).to({graphics:mask_graphics_88,x:-10.9774,y:8.5809}).wait(1).to({graphics:mask_graphics_89,x:-12.5452,y:7.2674}).wait(1).to({graphics:mask_graphics_90,x:-14.1969,y:6.0557}).wait(1).to({graphics:mask_graphics_91,x:-15.9201,y:4.9443}).wait(1).to({graphics:mask_graphics_92,x:-17.7038,y:3.933}).wait(1).to({graphics:mask_graphics_93,x:-19.5381,y:3.023}).wait(1).to({graphics:mask_graphics_94,x:-21.4146,y:2.2162}).wait(1).to({graphics:mask_graphics_95,x:-23.3257,y:1.5155}).wait(1).to({graphics:mask_graphics_96,x:-25.265,y:0.9248}).wait(1).to({graphics:mask_graphics_97,x:-27.2265,y:0.449}).wait(1).to({graphics:mask_graphics_98,x:-29.2042,y:0.0938}).wait(1).to({graphics:mask_graphics_99,x:-31.185,y:-0.1336}).wait(1).to({graphics:mask_graphics_100,x:-33.1267,y:-0.1}).wait(1));

	// Layer_2
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#0F97FF").s().p("AnUO0IgLAAIAA9nIALAAIABAAQGGAEEUESQEZEVAAGIQAAGJkZEVQkUERmGAFg");
	this.shape_2.setTransform(-0.05,0,0.7066,0.7066,0,0,0,-48.1,0);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#0F97FF").s().p("AAALAQkiAAjPjOQjOjOAAkkQAAkiDOjOQDPjPEiAAQEkAADODPQDODOAAEiQAAEkjODOQjODOkkAAIAAAAg");
	this.shape_3.setTransform(0.0476,0.1358,0.9404,0.9404);

	var maskedShapeInstanceList = [this.shape_2,this.shape_3];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2}]}).to({state:[{t:this.shape_3}]},49).wait(52));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-98.8,-98.8,197.7,197.7);


(lib.splashTextPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startbutton
	this.button = new lib.StartGameButton();
	this.button.name = "button";
	this.button.setTransform(266.45,401.8,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// bodyTextField
	this.bodyTextfield = new cjs.Text("InstructionsInstructionsInstructionsInstructi", "40px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 56;
	this.bodyTextfield.lineWidth = 894;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(70,231.798);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// titleTextField
	this.titleTextfield = new cjs.Text("Well spotted!", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 882;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(68.35,51.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// panelBG
	this.instance = new lib.EndscreenBGPanelShorter();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.splashTextPanel, new cjs.Rectangle(0,0,1002,509), null);


(lib.TimeoutPopup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Image
	this.instance = new lib.StopWatchIcon();
	this.instance.setTransform(-298.95,-140.7);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Text
	this.titleTextfield = new cjs.Text("titleTextfield", "bold 60px 'Poppins ExtraBold'", "#FA0002");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 66;
	this.titleTextfield.lineWidth = 487;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-180.4,-150.6);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// Button
	this.continueButton = new lib.StartGameButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-0.2,76.7,1,1,0,0,0,-0.2,2.7);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// PopupBG
	this.instance_1 = new lib.SmallPopupPanelBG();
	this.instance_1.setTransform(-341,-187);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TimeoutPopup, new cjs.Rectangle(-341,-187,682,374), null);


(lib.GenericPopup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text
	this.bodyTextfield = new cjs.Text("bodyTextfield\nLine2", "40px 'Arial'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 77;
	this.bodyTextfield.lineWidth = 866;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-435.55,-196.3);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.titleTextfield = new cjs.Text("titleTextfield", "50px 'Arial'", "#333333");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 89;
	this.titleTextfield.lineWidth = 866;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-435.55,-290.6);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.titleTextfield},{t:this.bodyTextfield}]}).wait(2));

	// Buttons
	this.cancelButton = new lib.StartGameButton_Overlay();
	this.cancelButton.name = "cancelButton";
	this.cancelButton.setTransform(236.3,246.1,2.7291,2.7272,0,0,0,-0.2,2.7);

	this.continueButton = new lib.StartGameButton_Overlay();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-232.2,246.1,2.7291,2.7272,0,0,0,-0.2,2.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.continueButton},{t:this.cancelButton}]}).wait(2));

	// PopupBG
	this.instance = new lib.PopupBG();
	this.instance.setTransform(-561.5,-393.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-561.5,-393.5,1123,787);


(lib.EndScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bg
	this.instance = new lib.EndScreen();
	this.instance.setTransform(-667.15,-1047.55);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// textPanel
	this.textPanel = new lib.splashTextPanel();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(-2,-470.5,1,1,0,0,0,501,369.5);

	this.timeline.addTween(cjs.Tween.get(this.textPanel).wait(1));

	// Background
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndScreenSkin, new cjs.Rectangle(-667.5,-1286,1746.9,2802), null);


(lib.ProgressDot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {unselected:0,selected:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop()
	}
	this.frame_16 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(16).call(this.frame_16).wait(1));

	// Layer_4
	this.instance = new lib.Dot("synched",0);
	this.instance.setTransform(0,0,0.6451,0.6451);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1.2903,scaleY:1.2903,alpha:1},16).wait(1));

	// Layer_1
	this.instance_1 = new lib.ProgressDotTween("synched",0);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1.3226,scaleY:1.3226},16).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-12.9,-12.9,25.8,25.8);


(lib.NudgeInstructions = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.actionTextField = new cjs.Text("(drag to continue)", "36px 'Poppins'");
	this.actionTextField.name = "actionTextField";
	this.actionTextField.lineHeight = 63;
	this.actionTextField.lineWidth = 645;
	this.actionTextField.parent = this;
	this.actionTextField.setTransform(-322.45,48.8479);
ranj.TextOffsetFixer.fix(this.actionTextField);

	this.bodyTextField = new cjs.Text("Drag the screen to see that you can move the map", "39px 'Poppins SemiBold'", "#0F5184");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 54;
	this.bodyTextField.lineWidth = 645;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(-322.45,-102.65);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.instance = new lib.TutorialStep3Container();
	this.instance.setTransform(-95.6,-83.3,1,1,0,0,0,265.9,102.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.bodyTextField},{t:this.actionTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NudgeInstructions, new cjs.Rectangle(-362,-133.5,724,267), null);


(lib.HudBottomTutorial = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bird placeholder
	this.instance = new lib.GreenOrange_01_tutorial();
	this.instance.setTransform(402,-20.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// continueButton
	this.continueButton = new lib.StartGameButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(810.1,111.1,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// button
	this.button = new lib.ChangeBirdButton();
	this.button.name = "button";
	this.button.setTransform(810.1,111.55,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// findLabelTextField
	this.findLabelTextfield = new cjs.Text("Gesucht wird", "45px 'Poppins SemiBold'", "#0F5184");
	this.findLabelTextfield.name = "findLabelTextfield";
	this.findLabelTextfield.lineHeight = 47;
	this.findLabelTextfield.lineWidth = 276;
	this.findLabelTextfield.parent = this;
	this.findLabelTextfield.setTransform(60.2,49.3);
ranj.TextOffsetFixer.fix(this.findLabelTextfield);

	this.timeline.addTween(cjs.Tween.get(this.findLabelTextfield).wait(1));

	// text short
	this.text = new cjs.Text("", "14px 'Poppins-Regular'", "#0F5184");
	this.text.textAlign = "center";
	this.text.lineHeight = 25;
	this.text.lineWidth = 100;
	this.text.parent = this;
	this.text.setTransform(65.2,4.3);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	// text
	this.text_1 = new cjs.Text("", "14px 'Roboto-Medium'", "#0F5184");
	this.text_1.textAlign = "center";
	this.text_1.lineHeight = 25;
	this.text_1.lineWidth = 100;
	this.text_1.parent = this;
	this.text_1.setTransform(65.2,4.3);
ranj.TextOffsetFixer.fix(this.text_1);

	this.timeline.addTween(cjs.Tween.get(this.text_1).wait(1));

	// bg
	this.instance_1 = new lib.BottomFloatingPanelBG();

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HudBottomTutorial, new cjs.Rectangle(0,-20.5,1046,241), null);


(lib.Hud = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// label texts
	this.timeLabelTextfield = new cjs.Text("xTime", "39px 'Poppins'", "#0F5184");
	this.timeLabelTextfield.name = "timeLabelTextfield";
	this.timeLabelTextfield.lineHeight = 70;
	this.timeLabelTextfield.lineWidth = 397;
	this.timeLabelTextfield.parent = this;
	this.timeLabelTextfield.setTransform(-448.65,24);
ranj.TextOffsetFixer.fix(this.timeLabelTextfield);

	this.mistakesLabelTextfield = new cjs.Text("xMistakes", "39px 'Poppins'", "#0F5184");
	this.mistakesLabelTextfield.name = "mistakesLabelTextfield";
	this.mistakesLabelTextfield.lineHeight = 70;
	this.mistakesLabelTextfield.lineWidth = 258;
	this.mistakesLabelTextfield.parent = this;
	this.mistakesLabelTextfield.setTransform(233.85,24);
ranj.TextOffsetFixer.fix(this.mistakesLabelTextfield);

	this.scoreLabelTextfield = new cjs.Text("xFound", "39px 'Poppins'", "#0F5184");
	this.scoreLabelTextfield.name = "scoreLabelTextfield";
	this.scoreLabelTextfield.lineHeight = 70;
	this.scoreLabelTextfield.lineWidth = 265;
	this.scoreLabelTextfield.parent = this;
	this.scoreLabelTextfield.setTransform(-34.75,24);
ranj.TextOffsetFixer.fix(this.scoreLabelTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.scoreLabelTextfield},{t:this.mistakesLabelTextfield},{t:this.timeLabelTextfield}]}).wait(1));

	// texts
	this.timeTextfield = new cjs.Text("00:00", "bold 39px 'Poppins'", "#0F5184");
	this.timeTextfield.name = "timeTextfield";
	this.timeTextfield.lineHeight = 70;
	this.timeTextfield.lineWidth = 379;
	this.timeTextfield.parent = this;
	this.timeTextfield.setTransform(-448.65,94);
ranj.TextOffsetFixer.fix(this.timeTextfield);

	this.mistakesTextfield = new cjs.Text("2", "bold 39px 'Poppins'", "#0F5184");
	this.mistakesTextfield.name = "mistakesTextfield";
	this.mistakesTextfield.lineHeight = 70;
	this.mistakesTextfield.lineWidth = 261;
	this.mistakesTextfield.parent = this;
	this.mistakesTextfield.setTransform(233.85,94);
ranj.TextOffsetFixer.fix(this.mistakesTextfield);

	this.scoreTextfield = new cjs.Text("7", "bold 39px 'Poppins'", "#0F5184");
	this.scoreTextfield.name = "scoreTextfield";
	this.scoreTextfield.lineHeight = 70;
	this.scoreTextfield.lineWidth = 247;
	this.scoreTextfield.parent = this;
	this.scoreTextfield.setTransform(-34.75,94);
ranj.TextOffsetFixer.fix(this.scoreTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.scoreTextfield},{t:this.mistakesTextfield},{t:this.timeTextfield}]}).wait(1));

	// bg
	this.hudBackground = new lib.HudBackground();
	this.hudBackground.name = "hudBackground";
	this.hudBackground.setTransform(0,84,1,1,0,0,0,498,84);

	this.timeline.addTween(cjs.Tween.get(this.hudBackground).wait(1));

	// practice indicator
	this.practiceIndicator = new lib.PracticeIndicatorSkin();
	this.practiceIndicator.name = "practiceIndicator";
	this.practiceIndicator.setTransform(0,10.1);

	this.timeline.addTween(cjs.Tween.get(this.practiceIndicator).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Hud, new cjs.Rectangle(-498,-76.5,996,244.5), null);


(lib.FeedbackPopupBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bgRight = new lib.FeedbackPopupBG_Right();
	this.bgRight.name = "bgRight";
	this.bgRight.setTransform(200.5,37.5,1,1,0,0,0,25,37.5);

	this.bgMid = new lib.FeedbackPopupBG_Middle();
	this.bgMid.name = "bgMid";
	this.bgMid.setTransform(113,37.5,1,1,0,0,0,63,37.5);

	this.bgLeft = new lib.FeedbackPopupBG_Left();
	this.bgLeft.name = "bgLeft";
	this.bgLeft.setTransform(25.5,37.5,1,1,0,0,0,25,37.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bgLeft},{t:this.bgMid},{t:this.bgRight}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG, new cjs.Rectangle(0.5,0,225,75), null);


(lib.PrevButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#0F5184");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 276;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#0F5184");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 276;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 276;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#DDE5EF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 276;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.BackUp();
	this.instance.setTransform(-152,-18);

	this.instance_1 = new lib.BackDown();
	this.instance_1.setTransform(-152,-18);

	this.instance_2 = new lib.BackDisabled();
	this.instance_2.setTransform(-152,-18);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},1).to({state:[]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(17.95,0.3,2.8787,1.5699,0,0,0,0.1,0.1);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-158.6,-31,352.6,83.3);


(lib.BirdPlaceholder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// circle
	this.instance = new lib.BirdTEMP();
	this.instance.setTransform(-0.95,-1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BirdPlaceholder, new cjs.Rectangle(-132.7,-213.8,225.7,213.9), null);


(lib.Timer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// border
	this.instance = new lib.SpotterTimerOutline();
	this.instance.setTransform(-71.5,-71.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Fill
	this.TimerFill = new lib.TimerFill();
	this.TimerFill.name = "TimerFill";
	this.TimerFill.setTransform(-0.05,0);

	this.timeline.addTween(cjs.Tween.get(this.TimerFill).wait(1));

	// bg
	this.instance_1 = new lib.SpotterTimerBG();
	this.instance_1.setTransform(-71.5,-71.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Timer, new cjs.Rectangle(-71.5,-71.5,143,143), null);


(lib.GateKeeperOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// nextButton
	this.button2 = new lib.StartGameButton();
	this.button2.name = "button2";
	this.button2.setTransform(245.2,729.6,1,1,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.button2).wait(1));

	// prevButton
	this.button1 = new lib.PrevButton();
	this.button1.name = "button1";
	this.button1.setTransform(-318.7,720,1,1,0,0,0,-41,0.1);

	this.timeline.addTween(cjs.Tween.get(this.button1).wait(1));

	// titleTextfield
	this.titleTextfield = new cjs.Text("NameBlah\nBlahhh", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 941;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-436.6506,-768.95);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// bodyTextfield
	this.bodyTextfield = new cjs.Text("• [Instructions]", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 66;
	this.bodyTextfield.lineWidth = 857;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-422.6,-506.65);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// lines
	this.lines = new lib.GateKeeperOverlayLines();
	this.lines.name = "lines";
	this.lines.setTransform(-34.45,-587);

	this.timeline.addTween(cjs.Tween.get(this.lines).wait(1));

	// Titles
	this.titleTextfield_1 = new cjs.Text("xGatekeeper", "20px 'Arial'", "#FFFFFF");
	this.titleTextfield_1.name = "titleTextfield_1";
	this.titleTextfield_1.lineHeight = 27;
	this.titleTextfield_1.lineWidth = 283;
	this.titleTextfield_1.parent = this;
	this.titleTextfield_1.setTransform(-423.5,-590.8,3,3);
ranj.TextOffsetFixer.fix(this.titleTextfield_1);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield_1).wait(1));

	// panel bg
	this.bg = new lib.GateKeeperOverlayBackground();
	this.bg.name = "bg";
	this.bg.setTransform(0,0,1,1,0,0,0,540,871.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	// overlay
	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(17.95,-4.4,1.0217,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GateKeeperOverlaySkin, new cjs.Rectangle(-720.1,-1180.2,1803.5,2300.5), null);


(lib.FeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// body
	this.bodyTextfield = new cjs.Text("abcdef ", "40px 'Arial'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "center";
	this.bodyTextfield.lineHeight = 72;
	this.bodyTextfield.lineWidth = 149;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-0.7498,9.8);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.bg = new lib.FeedbackPopupBG();
	this.bg.name = "bg";
	this.bg.setTransform(-2,34.25,1,1,0,0,0,112,37.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPanel, new cjs.Rectangle(-113.5,-3.2,225,85.5), null);


(lib.DragNudgeSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// instructions
	this.instructions = new lib.NudgeInstructions();
	this.instructions.name = "instructions";
	this.instructions.setTransform(0,-377.3);

	this.timeline.addTween(cjs.Tween.get(this.instructions).wait(1));

	// nudgeGraphic
	this.nudge = new lib.DragNudge();
	this.nudge.name = "nudge";
	this.nudge.setTransform(-20,116.05);

	this.timeline.addTween(cjs.Tween.get(this.nudge).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DragNudgeSkin, new cjs.Rectangle(-527.8,-868.1,1063.1999999999998,1707.5), null);


(lib.TutorialBackgroundScore = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// masklayer (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("Eg6CAgMQj4AAiwiwQiwivAAj5MAAAgtnQAAj5CwiwQCwivD4AAMB0FAAAQD4AACwCvQCwCwAAD5MAAAAtnQAAD5iwCvQiwCwj4AAg");
	mask.setTransform(0,205.5);

	// hud
	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(-105,116);

	var maskedShapeInstanceList = [this.hud];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.hud).wait(1));

	// bg
	this.instance = new lib.Birdtut2();
	this.instance.setTransform(-431.5,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundScore, new cjs.Rectangle(-667.5,-1238,1335,2476), null);


(lib.TutorialBackgroundPractice = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hud
	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(-2.05,85.65,0.8124,0.8124,0,0,0,-0.1,0.2);

	this.timeline.addTween(cjs.Tween.get(this.hud).wait(1));

	// bg
	this.instance = new lib.Birdtut5();
	this.instance.setTransform(-431,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundPractice, new cjs.Rectangle(-815.5,-1238,1631,2524.1), null);


(lib.TutorialBackgroundNext = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// masklayer (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("Eg6CAgMQj4AAiwiwQiwivAAj5MAAAgtnQAAj5CwiwQCwivD4AAMB0FAAAQD4AACwCvQCwCwAAD5MAAAAtnQAAD5iwCvQiwCwj4AAg");
	mask.setTransform(0,205.5);

	// hudBottom
	this.hudBottom = new lib.HudBottomTutorial();
	this.hudBottom.name = "hudBottom";
	this.hudBottom.setTransform(-657,153);

	var maskedShapeInstanceList = [this.hudBottom];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.hudBottom).wait(1));

	// bg
	this.instance = new lib.Birdtut2();
	this.instance.setTransform(-431.5,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EAAAhU2MAAACpt");
	this.shape.setTransform(440.3,177.15);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundNext, new cjs.Rectangle(-667.5,-1238,1335,2476), null);


(lib.ProgressDots_MC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.dot4 = new lib.ProgressDot();
	this.dot4.name = "dot4";
	this.dot4.setTransform(57.2,0.15);

	this.dot0 = new lib.ProgressDot();
	this.dot0.name = "dot0";
	this.dot0.setTransform(-57.2,0.15);

	this.dot3 = new lib.ProgressDot();
	this.dot3.name = "dot3";
	this.dot3.setTransform(28.6,0.05);

	this.dot1 = new lib.ProgressDot();
	this.dot1.name = "dot1";
	this.dot1.setTransform(-28.6,0);

	this.dot2 = new lib.ProgressDot();
	this.dot2.name = "dot2";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dot2},{t:this.dot1},{t:this.dot3},{t:this.dot0},{t:this.dot4}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressDots_MC, new cjs.Rectangle(-66.2,-9,132.4,18.2), null);


(lib.HudBottom = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bird placeholder
	this.bird = new lib.BirdPlaceholder();
	this.bird.name = "bird";
	this.bird.setTransform(457.95,199.5,1,1,0,0,0,-16.3,-1.1);

	this.timeline.addTween(cjs.Tween.get(this.bird).wait(1));

	// continueButton
	this.continueButton = new lib.StartGameButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(810.1,111.1,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// button
	this.button = new lib.ChangeBirdButton();
	this.button.name = "button";
	this.button.setTransform(810.1,111.55,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// findLabelTextField
	this.findLabelTextfield = new cjs.Text("Gesucht wird", "45px 'Poppins SemiBold'", "#0F5184");
	this.findLabelTextfield.name = "findLabelTextfield";
	this.findLabelTextfield.lineHeight = 47;
	this.findLabelTextfield.lineWidth = 276;
	this.findLabelTextfield.parent = this;
	this.findLabelTextfield.setTransform(60.2,49.3);
ranj.TextOffsetFixer.fix(this.findLabelTextfield);

	this.timeline.addTween(cjs.Tween.get(this.findLabelTextfield).wait(1));

	// text short
	this.text = new cjs.Text("", "14px 'Poppins-Regular'", "#0F5184");
	this.text.textAlign = "center";
	this.text.lineHeight = 25;
	this.text.lineWidth = 100;
	this.text.parent = this;
	this.text.setTransform(65.2,4.3);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	// text
	this.text_1 = new cjs.Text("", "14px 'Roboto-Medium'", "#0F5184");
	this.text_1.textAlign = "center";
	this.text_1.lineHeight = 25;
	this.text_1.lineWidth = 100;
	this.text_1.parent = this;
	this.text_1.setTransform(65.2,4.3);
ranj.TextOffsetFixer.fix(this.text_1);

	this.timeline.addTween(cjs.Tween.get(this.text_1).wait(1));

	// bg
	this.instance = new lib.BottomFloatingPanelBG();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HudBottom, new cjs.Rectangle(0,0,1046,214), null);


(lib.TutorialOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.button = new lib.StartGameButton();
	this.button.name = "button";
	this.button.setTransform(245.2,729.6,1,1,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(4));

	// nextButton
	this.nextButton = new lib.StartGameButton();
	this.nextButton.name = "nextButton";
	this.nextButton.setTransform(245.2,729.6,1,1,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.nextButton).wait(4));

	// prevButton
	this.prevButton = new lib.PrevButton();
	this.prevButton.name = "prevButton";
	this.prevButton.setTransform(-318.7,720,1,1,0,0,0,-41,0.1);

	this.timeline.addTween(cjs.Tween.get(this.prevButton).wait(4));

	// Progress dots
	this.progressDots = new lib.ProgressDots_MC();
	this.progressDots.name = "progressDots";
	this.progressDots.setTransform(-46.65,728.9,0.9,0.9,0,0,0,-0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.progressDots).wait(4));

	// titleTextfield
	this.titleTextfield = new cjs.Text("NameBlah\nBlahhh", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 941;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-436.6506,-768.95);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(4));

	// bodyTextfield
	this.bodyTextfield = new cjs.Text("• [Instructions]", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 66;
	this.bodyTextfield.lineWidth = 857;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-422.6,-506.65);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(4));

	// Line1
	this.lines1 = new lib.TutorialLines1();
	this.lines1.name = "lines1";
	this.lines1.setTransform(5.4,267.55);

	this.timeline.addTween(cjs.Tween.get(this.lines1).wait(4));

	// Line2
	this.lines2 = new lib.TutorialLines3();
	this.lines2.name = "lines2";
	this.lines2.setTransform(-260.8,-590);

	this.timeline.addTween(cjs.Tween.get(this.lines2).wait(4));

	// Line3
	this.lines3 = new lib.TutorialLines2();
	this.lines3.name = "lines3";
	this.lines3.setTransform(5.2,-366.1,1,1,0,0,0,-0.1,-603.1);

	this.timeline.addTween(cjs.Tween.get(this.lines3).wait(4));

	// Line4
	this.lines4 = new lib.TutorialLines4();
	this.lines4.name = "lines4";
	this.lines4.setTransform(-34.45,-449.4);

	this.timeline.addTween(cjs.Tween.get(this.lines4).wait(4));

	// Line5
	this.lines5 = new lib.TutorialLines5();
	this.lines5.name = "lines5";
	this.lines5.setTransform(-16.4,-449.5,1.1079,1,0,0,0,-0.1,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.lines5).wait(4));

	// bg1
	this.bg1 = new lib.TutorialBackgroundBird();
	this.bg1.name = "bg1";
	this.bg1.setTransform(0,180);
	this.bg1.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg1).wait(4));

	// bg2
	this.bg2 = new lib.TutorialBackgroundScore();
	this.bg2.name = "bg2";
	this.bg2.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg2).wait(4));

	// bg3
	this.bg3 = new lib.TutorialBackgroundNext();
	this.bg3.name = "bg3";
	this.bg3.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg3).wait(4));

	// bg4
	this.bg4 = new lib.TutorialBackgroundMap();
	this.bg4.name = "bg4";
	this.bg4.setTransform(816,1114,1,1,0,0,0,816,1204);
	this.bg4.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg4).wait(4));

	// bg5
	this.bg5 = new lib.TutorialBackgroundPractice();
	this.bg5.name = "bg5";
	this.bg5.setTransform(0,190);
	this.bg5.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg5).wait(4));

	// panel bg
	this.instance = new lib.BigPanelBG();
	this.instance.setTransform(-540,-871.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// overlay
	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(17.95,-4.4,1.0217,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-672.8,-1184.2,1752.2,2254.5);


(lib.GameScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hudBottom
	this.hudBottom = new lib.HudBottom();
	this.hudBottom.name = "hudBottom";
	this.hudBottom.setTransform(-522.75,625.35);

	this.timeline.addTween(cjs.Tween.get(this.hudBottom).wait(1));

	// hud
	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(0,-768);

	this.timeline.addTween(cjs.Tween.get(this.hud).wait(1));

	// level
	this.level = new lib.LevelPlaceholder();
	this.level.name = "level";
	this.level.setTransform(-540,-868.15);

	this.timeline.addTween(cjs.Tween.get(this.level).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameScreenSkin, new cjs.Rectangle(-762.1,-1184.2,1841.5,2239.2), null);


// stage content:
(lib.MainAssetsRedesign = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// generic popup
	this.instance = new lib.GenericPopup();
	this.instance.setTransform(-742.05,546.55);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// popup
	this.popup = new lib.TimeoutPopup();
	this.popup.name = "popup";
	this.popup.setTransform(-742.05,1379.7);

	this.timeline.addTween(cjs.Tween.get(this.popup).wait(1));

	// Layer_2
	this.instance_1 = new lib.DragNudgeSkin();
	this.instance_1.setTransform(-376.75,2016.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// feedbackPanel
	this.feedbackPanel = new lib.FeedbackPanel();
	this.feedbackPanel.name = "feedbackPanel";
	this.feedbackPanel.setTransform(-736.75,61.25,1,1,0,0,0,-3.5,31.4);

	this.timeline.addTween(cjs.Tween.get(this.feedbackPanel).wait(1));

	// gatekeeper
	this.instance_2 = new lib.GateKeeperOverlaySkin();
	this.instance_2.setTransform(543.8,870.7,1,1,0,0,0,3.8,-0.3);
	this.instance_2.cache(-722,-1182,1808,2305);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// tutorial
	this.instance_3 = new lib.TutorialOverlaySkin();
	this.instance_3.setTransform(543.8,870.7,1,1,0,0,0,3.8,-0.3);
	this.instance_3.cache(-675,-1186,1756,2259);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// endscreen
	this.instance_4 = new lib.EndScreenSkin();
	this.instance_4.setTransform(1941.45,871);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// gamescreen
	this.instance_5 = new lib.GameScreenSkin();
	this.instance_5.setTransform(540,986,1,1,0,0,0,0,115);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-763.5,456,3372,1931);
// library properties:
lib.properties = {
	id: 'F7DD7F692B0D1D44A7B614DFFAE812BF',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#0F97FF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/MainAssets/BackDisabled.png", id:"MainAssets_BackDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackDown.png", id:"MainAssets_BackDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Background_Blue.png", id:"MainAssets_Background_Blue", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackUp.png", id:"MainAssets_BackUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BigPanelBG.png", id:"MainAssets_BigPanelBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Birdtut1.png", id:"MainAssets_Birdtut1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Birdtut2.png", id:"MainAssets_Birdtut2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Birdtut3.png", id:"MainAssets_Birdtut3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Birdtut5.png", id:"MainAssets_Birdtut5", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BottomFloatingPanelBG.png", id:"MainAssets_BottomFloatingPanelBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_disabled.png", id:"MainAssets_Button_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_down.png", id:"MainAssets_Button_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_up.png", id:"MainAssets_Button_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/EndScreen.png", id:"MainAssets_EndScreen", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/EndscreenBGPanelShorter.png", id:"MainAssets_EndscreenBGPanelShorter", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Left.png", id:"MainAssets_FeedbackPopup_Left", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Middle.png", id:"MainAssets_FeedbackPopup_Middle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Right.png", id:"MainAssets_FeedbackPopup_Right", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/GreenOrange_01.png", id:"MainAssets_GreenOrange_01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/GreenOrange_01_tutorial.png", id:"MainAssets_GreenOrange_01_tutorial", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/HUDPanelTop.png", id:"MainAssets_HUDPanelTop", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/HUDPracticePanelBG.png", id:"MainAssets_HUDPracticePanelBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonDis.png", id:"MainAssets_MainButtonDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonDown.png", id:"MainAssets_MainButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonHi.png", id:"MainAssets_MainButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonUp.png", id:"MainAssets_MainButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MoveNudge.png", id:"MainAssets_MoveNudge", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PopupBG.png", id:"MainAssets_PopupBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/SmallPopupPanelBG.png", id:"MainAssets_SmallPopupPanelBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/SpotterTimerBG.png", id:"MainAssets_SpotterTimerBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/SpotterTimerOutline.png", id:"MainAssets_SpotterTimerOutline", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/StopWatchIcon.png", id:"MainAssets_StopWatchIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/WhiteArrow.png", id:"MainAssets_WhiteArrow", bundle:"MainAssets"}
	],
	preloads: []
};



})(lib.MainAssets = {}, images, ss, createjs);
module.exports = lib.MainAssets;